import { render, staticRenderFns } from "./CreateOrganizationAdminLayout.vue?vue&type=template&id=b25b689e&scoped=true&"
import script from "./CreateOrganizationAdminLayout.vue?vue&type=script&lang=js&"
export * from "./CreateOrganizationAdminLayout.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrganizationAdminLayout.vue?vue&type=style&index=0&id=b25b689e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25b689e",
  null
  
)

export default component.exports